export default __webpack_public_path__ + "static/media/if-you-are-1.4f39e6b6.svg";